const PLANNING_EXPENSE_TYPES = [{ value: 'pax', label: 'pax' }, { value: 'avg', label: 'avg' }];

export default PLANNING_EXPENSE_TYPES;
